'use strict';

/**
 * Theme-specific VUGRON functions
 * */

// eslint-disable-next-line no-redeclare
var VUGRON = VUGRON || {};
VUGRON.Muziekschool_V2 = {};
VUGRON.Muziekschool_V2.Main = function($) {

}(jQuery);

$(function() {
    // always init datepickers  when calc price form is loaded (i.e. course subscribe pages -> birthdate input)
    let form_calc_price = document.getElementById('calc_price');
    if (typeof (form_calc_price) !== "undefined" && form_calc_price != null) {
        VUGRON.Main.set_datepickers();
    }
});
